import { render, staticRenderFns } from "./BlockContents.vue?vue&type=template&id=1c35bf0c&scoped=true&"
import script from "./BlockContents.vue?vue&type=script&lang=js&"
export * from "./BlockContents.vue?vue&type=script&lang=js&"
import style0 from "./BlockContents.vue?vue&type=style&index=0&id=1c35bf0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c35bf0c",
  null
  
)

export default component.exports